import { Badge } from '@/components/ui/badge'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { ProcessorDetails } from '@/lib/api/processors'
import { ProcessorHeader } from '../components/processor-header'
import { ProcessorOverviewCard } from '../components/processor-overview-card'
import { ProcessorMetricsCard } from '../components/processor-metrics-card'
import { ProcessorPaymentMethodsCard } from '../components/processor-payment-methods-card'

interface Props { processor: ProcessorDetails }

const RazorpayConfigurationCard = ({ processor }: Props) => {
    const options = processor.options as Record<string, any> | null
    return (
        <Card className="mb-6">
            <CardHeader><CardTitle>Razorpay Configuration</CardTitle></CardHeader>
            <CardContent>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <p className="text-sm text-muted-foreground">Key ID</p>
                        <p className="font-mono text-sm">{options?.keyId || 'Not configured'}</p>
                    </div>
                    <div>
                        <p className="text-sm text-muted-foreground">Key Secret</p>
                        <p className="font-mono text-sm">••••••••••••••••</p>
                    </div>
                    <div>
                        <p className="text-sm text-muted-foreground">Environment</p>
                        <Badge variant={options?.testMode ? 'outline' : 'default'}>
                            {options?.testMode ? 'Test' : 'Live'}
                        </Badge>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}

export const RazorpayProcessorDetailsPage = ({ processor }: Props) => (
    <>
        <ProcessorHeader type="razorpay" processor={processor} />
        <ProcessorOverviewCard processor={processor} />
        <ProcessorMetricsCard processor={processor} />
        <RazorpayConfigurationCard processor={processor} />
        <ProcessorPaymentMethodsCard processor={processor} />
    </>
)
